import classNames from "classnames";
import { exclamationIcon } from "../../../assets/icons";

const SuggestionBar = ({ text, handleOnClick, link, classes }) => {
  return (
    <div className="flex items-center bg-gray-800 py-5 px-5 rounded-r-md mb-4 border-l-4 border-gray-400">
      <div className="icon mr-3">
        <img src={exclamationIcon} width="20" alt="exclamation-icon" />
      </div>
      <div className={classNames("text-sm font-medium", classes)}>
        {text}
        {link && (
          <span
            className="underline font-bold text-blue-400 text-sm m-1 cursor-pointer"
            onClick={() => handleOnClick()}
          >
            {link}
          </span>
        )}
      </div>
    </div>
  );
};
export default SuggestionBar;
